




import {defineComponent, PropType} from "@vue/composition-api";
import VueApexCharts from "vue-apexcharts";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import moment from "moment";
import {ClickStat} from "@tool/Pages/App/Project/Reports/reports.types";

export default defineComponent({
    components: {
        VueApexCharts,
        ThemeBlock,
    },
    props: {
        clicks: {
            type: Array as PropType<ClickStat[]>,
            required: true
        }
    },
    setup(props) {
        const series = [{
            name: 'Clicks',
            data: props.clicks.map(click => {
                return {
                    x: moment(click.date).format('YYYY-MM-DD'),
                    y: click.clicks
                }
            })
        }];

        const chartOptions: ApexCharts.ApexOptions = {
            chart: {
                zoom: {
                    enabled: false
                },
                toolbar: {
                    show: false
                },
            },
            colors: ['#0665d0'],
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: 'smooth'
            },
            markers: {
                size: 6
            },
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            yaxis: {
                min: 0,
                labels: {
                    formatter: function (val) {
                        return val.toFixed(0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                    }
                },

            },
            xaxis: {
                type: "datetime",
                labels: {
                    formatter: (val: string) => {
                        /**
                         * Trick to align dates with graph
                         */
                        return moment(val).utc().format('MMM D')
                    }
                }
            },
        };


        return {
            series,
            chartOptions,
        }
    }
})
